var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45703 11.459C6.16602 11.459 6.62891 10.9609 6.62891 10.2109V4.92578L6.57617 3.68359L7.16797 4.42773L8.47461 5.74023C8.68555 5.95703 8.94922 6.12695 9.31836 6.12695C9.94531 6.12695 10.4258 5.67578 10.4258 5.00195C10.4258 4.69141 10.2969 4.39844 10.0566 4.16406L6.31836 0.419922C6.11328 0.214844 5.77344 0.0859375 5.45703 0.0859375C5.14062 0.0859375 4.79492 0.214844 4.5957 0.419922L0.857422 4.16406C0.623047 4.39844 0.494141 4.69141 0.494141 5.00195C0.494141 5.67578 0.974609 6.12695 1.60156 6.12695C1.9707 6.12695 2.22852 5.95703 2.44531 5.74023L3.74023 4.42773L4.33789 3.68359L4.2793 4.92578V10.2109C4.2793 10.9609 4.74805 11.459 5.45703 11.459Z",
    fill: "#389D5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.522c07ff5496356b85f6e7d3718bb683.svg";
export { ForwardRef as ReactComponent };